import { DropdownOption } from '@ap/dropdown';

export class DropDownOptionBuilder {
    private value: any;
    private label: string;

    withValue(value: any) {
        this.value = value;
        return this;
    }

    withLabel(label: string) {
        this.label = label;
        return this;
    }

    build(): DropdownOption {
        return {
            value: this.value,
            label: this.label
        };
    }
}
